import { HeadingAppearance, Size } from './Heading.types';

const headingDriverFactory = (factoryParams: { element: HTMLElement }) => {
  const { element } = factoryParams;

  return {
    exists: () => !!element,
    getAppearance: () =>
      element.getAttribute('data-appearance') as HeadingAppearance | null,
    getSize: () => element.getAttribute('data-size') as Size | null,
    getTagName: () => element.tagName as keyof HTMLElementTagNameMap,
    getText: () => element.innerHTML,
    isLight: () => element.getAttribute('data-light') === 'true',
    isMasked: () => element.getAttribute('data-mask') === 'true',
    getId: () => element.getAttribute('data-id')!,
  };
};

export default headingDriverFactory;

export type HeadingDriver = ReturnType<typeof headingDriverFactory>;
